"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.list.name': 'Nombre de la Prueba',
    'botTest.list.date': 'Fecha de Prueba',
    'botTest.list.testersCount': 'Probadores',
    'botTest.list.targetsCount': 'Objetivos',
};
